// eslint-disable-next-line import/prefer-default-export
export function notNull<T>(val: T | null): val is T {
  return val !== null;
}
